import Layout from '../../components/layout/Layout';
import Breadcrumb from '../../components/layout/Breadcrumb';
import { useState } from 'react';
import { Link } from 'react-router-dom';

// BTN-08（明背景）: 紺塗り+真鍮枠+生成り文字→hover真鍮塗り+紺枠。二重枠は before で表現。
const BTN08_ON_LIGHT = "relative inline-flex items-center justify-center bg-[#1a2942] text-[#f8f6f0] border border-[#a38e65] px-[46px] py-[18px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#a38e65] hover:text-[#1a2942] hover:border-[#1a2942] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#a38e65]/45 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#1a2942]/45";

export default function News() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortOrder, setSortOrder] = useState('desc'); // desc=最新順 / asc=古い順

  const breadcrumbs = [
    { label: 'ホーム', href: '/' },
    { label: 'ニュース・お知らせ' }
  ];

  const categories = [
    { id: 'all', label: 'すべて' },
    { id: 'important', label: '重要' },
    { id: 'report', label: '報告' },
    { id: 'event', label: 'イベント' },
    { id: 'industry', label: '業界動向' },
    { id: 'technology', label: 'テクノロジー' },
    { id: 'education', label: '教育' }
  ];

  const newsItems = [
    { id: 1784434432790, title: "英国の私邸とエステートでホスピタリティが特別なプライベートイベントを形作る", date: "2026.06.30", dateSort: "2026-06-30", category: 'industry', categoryLabel: '業界動向', link: "/news/how-hospitality-shapes-exceptional-private-events" },

    { id: 1784434164494, title: "育児の枠を超えて：英国UHNWナニーの拡大する役割", date: "2026.07.09", dateSort: "2026-07-09", category: 'industry', categoryLabel: '業界動向', link: "/news/beyond-childcare-the-role-of-the-uhnw-nanny" },

    { id: 1784433961163, title: "アップスキリングが再定義する海外プライベート家庭の役割", date: "2026.07.16", dateSort: "2026-07-16", category: 'industry', categoryLabel: '業界動向', link: "/news/how-upskilling-is-redefining-private-household-roles" },

    { id: 1, title: 'Raffles London「The Butler Did It」キャンペーン第2章', date: '2025年9月17日', dateSort: '2025-09-17', category: 'industry', categoryLabel: '業界動向', link: '/news/raffles-london-campaign' },
    { id: 2, title: 'Downton Abbey: The Grand Finale 映画公開', date: '2025年9月12日', dateSort: '2025-09-12', category: 'event', categoryLabel: 'イベント', link: '/news/downton-abbey-grand-finale' },
    { id: 3, title: 'Raffles Hotels & Resorts グローバルブランドキャンペーン「The Butler Did It」', date: '2024年9月10日', dateSort: '2024-09-10', category: 'industry', categoryLabel: '業界動向', link: '/news/raffles-butler-campaign' },
    { id: 4, title: 'Apple社ロボットバトラー開発プロジェクト始動', date: '2024年4月4日', dateSort: '2024-04-04', category: 'technology', categoryLabel: 'テクノロジー', link: '/news/apple-robot-butler' },
    { id: 5, title: 'Raffles Sentosa 高級エスケープパッケージ（1泊4,985SGDから）', date: '2025年10月15日', dateSort: '2025-10-15', category: 'important', categoryLabel: '重要', link: '/news/raffles-sentosa-butler-package' },
    { id: 6, title: 'AIホスピタリティ革命', date: '2025年8月14日', dateSort: '2025-08-14', category: 'technology', categoryLabel: 'テクノロジー', link: '/news/ai-hospitality-revolution' },
    { id: 7, title: 'グラント・ハロルド王室バトラー回顧録出版', date: '2025年8月1日', dateSort: '2025-08-01', category: 'report', categoryLabel: '報告', link: '/news/grant-harrold-royal-butler-memoir' },
    { id: 8, title: 'スイス超豪華旅行ブーム（プライベートスキーバトラー）', date: '2025年3月3日', dateSort: '2025-03-03', category: 'industry', categoryLabel: '業界動向', link: '/news/swiss-luxury-travel-ski-butler' },
    { id: 9, title: '香港Butler AI 黒字化達成', date: '2025年2月1日', dateSort: '2025-02-01', category: 'technology', categoryLabel: 'テクノロジー', link: '/news/hong-kong-butler-ai-profitability' },
    { id: 10, title: 'TIBA 5年連続グローバルアワード受賞', date: '2024年12月20日', dateSort: '2024-12-20', category: 'report', categoryLabel: '報告', link: '/news/tiba-global-award-five-years' },
    { id: 11, title: '中国富裕層のバトラー需要急増', date: '2024年12月4日', dateSort: '2024-12-04', category: 'industry', categoryLabel: '業界動向', link: '/news/china-butler-demand-surge' },
    { id: 12, title: 'Jumeirah Burj Al Arab 25周年記念', date: '2024年11月30日', dateSort: '2024-11-30', category: 'event', categoryLabel: 'イベント', link: '/news/jumeirah-burj-al-arab-25th-anniversary' },
    { id: 13, title: '世界的な執事不足により年収13万ドル超えが報告', date: '2024年10月15日', dateSort: '2024-10-15', category: 'important', categoryLabel: '重要', link: '/news/global-butler-shortage-salary-surge' },
    { id: 14, title: 'Weave Robotics Isaac 家庭用ロボットバトラー発表', date: '2024年9月9日', dateSort: '2024-09-09', category: 'technology', categoryLabel: 'テクノロジー', link: '/news/weave-robotics-isaac-robot-butler' },
    { id: 15, title: 'Blue Diamond Resorts 大規模バトラー認定プログラム完了', date: '2024年7月29日', dateSort: '2024-07-29', category: 'education', categoryLabel: '教育' },
    { id: 16, title: 'SABA 国際バトラーデー', date: '2024年7月29日', dateSort: '2024-07-29', category: 'event', categoryLabel: 'イベント' },
    { id: 17, title: 'The Dorchester 新バトラープログラム導入', date: '2024年6月17日', dateSort: '2024-06-17', category: 'industry', categoryLabel: '業界動向' },
    { id: 18, title: 'St. Regis New York 120周年記念モバイルシャンパンバトラー', date: '2024年6月17日', dateSort: '2024-06-17', category: 'event', categoryLabel: 'イベント' },
    { id: 19, title: 'Bloomberg特集：Raffles Singapore Butler Secrets', date: '2024年2月22日', dateSort: '2024-02-22', category: 'industry', categoryLabel: '業界動向' }
  ];

  const filteredNews = selectedCategory === 'all'
    ? newsItems
    : newsItems.filter(item => item.category === selectedCategory);

  const sortedNews = [...filteredNews].sort((a, b) =>
    sortOrder === 'desc'
      ? new Date(b.dateSort).getTime() - new Date(a.dateSort).getTime()
      : new Date(a.dateSort).getTime() - new Date(b.dateSort).getTime()
  );

  const dotted = (iso: string) => iso.replace(/-/g, '.');

  return (
    <Layout>
      <title>ニュース・お知らせ | 全日本執事協会</title>
      <meta name="description" content="全日本執事協会の最新ニュース、業界動向、資格制度の更新情報、研修プログラムのお知らせなど、執事業界に関する情報を発信しています。" />
      <link rel="canonical" href="https://butler-association.jp/news" />

      {/* ===== ヒーロー（紺・エディトリアル） ===== */}
      <section className="relative bg-[#1a2942] overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-25"
          style={{ backgroundImage: `url('/images/generated/jba-fs-104-news.jpg')` }}
        ></div>
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(26,41,66,0.72),rgba(10,12,14,0.86))]"></div>
        <div className="relative z-10 max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 py-20 sm:py-24 lg:py-28 text-left">
          <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.34em] text-xs sm:text-[13px] text-[#d7b779]">News &amp; Updates</span>
          <div className="w-14 h-px bg-[#a38e65] my-5"></div>
          <h1 className="jba-display font-normal text-white text-[clamp(28px,3.4vw,44px)] leading-[1.35] tracking-[0.04em] max-w-3xl">
            執事文化の「いま」を伝える<br className="hidden sm:block" />ニュース・お知らせ
          </h1>
          <p className="mt-6 font-['Noto_Serif_JP',serif] text-base sm:text-lg leading-[1.95] text-[#e7e2d8]/95 max-w-3xl">
            世界のラグジュアリーホテルにおけるバトラーサービスの潮流から、テクノロジーとおもてなしの融合、協会の活動報告まで。執事業界の最新動向を、確かな出典とともにお届けします。
          </p>
        </div>
      </section>
      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      {/* ===== 絞り込み（種別）＋並び順 ===== */}
      <section className="bg-white border-b border-[#e2ddd2]">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 py-8 sm:py-10">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            {/* 種別フィルター */}
            <div>
              <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.24em] text-[11px] text-[#8f7a56] mb-3">Category</span>
              <div className="flex flex-wrap gap-2 sm:gap-2.5">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategory(category.id)}
                    className={`shrink-0 whitespace-nowrap border px-4 py-2 text-[13px] tracking-[0.04em] font-['Noto_Serif_JP',serif] transition-colors duration-300 cursor-pointer ${
                      selectedCategory === category.id
                        ? 'bg-[#1a2942] text-[#f8f6f0] border-[#1a2942]'
                        : 'bg-white text-[#8f7a56] border-[#a38e65]/60 hover:bg-[#f8f6f0]'
                    }`}
                  >
                    {category.label}
                  </button>
                ))}
              </div>
            </div>

            {/* 並び順 */}
            <div>
              <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.24em] text-[11px] text-[#8f7a56] mb-3 lg:text-right">Sort</span>
              <div className="flex gap-2 sm:gap-2.5">
                <button
                  onClick={() => setSortOrder('desc')}
                  className={`inline-flex items-center gap-1.5 whitespace-nowrap border px-4 py-2 text-[13px] tracking-[0.04em] font-['Noto_Serif_JP',serif] transition-colors duration-300 cursor-pointer ${
                    sortOrder === 'desc'
                      ? 'bg-[#1a2942] text-[#f8f6f0] border-[#1a2942]'
                      : 'bg-white text-[#8f7a56] border-[#a38e65]/60 hover:bg-[#f8f6f0]'
                  }`}
                >
                  <i className="ri-arrow-down-line"></i>最新順
                </button>
                <button
                  onClick={() => setSortOrder('asc')}
                  className={`inline-flex items-center gap-1.5 whitespace-nowrap border px-4 py-2 text-[13px] tracking-[0.04em] font-['Noto_Serif_JP',serif] transition-colors duration-300 cursor-pointer ${
                    sortOrder === 'asc'
                      ? 'bg-[#1a2942] text-[#f8f6f0] border-[#1a2942]'
                      : 'bg-white text-[#8f7a56] border-[#a38e65]/60 hover:bg-[#f8f6f0]'
                  }`}
                >
                  <i className="ri-arrow-up-line"></i>古い順
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== ニュース一覧（エディトリアル・リスト行：日付＋固定幅種別チップ＋タイトル＋詳しく→） ===== */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="border-t border-[#e2ddd2]">
            {sortedNews.map((news) => (
              news.link ? (
                <Link
                  key={news.id}
                  to={news.link}
                  className="group flex items-center gap-4 sm:gap-6 py-5 border-b border-[#e2ddd2] hover:bg-[#f8f6f0]/60 transition-colors duration-300"
                >
                  <span className="font-['Playfair_Display',serif] italic text-[#8f7a56] text-sm shrink-0 w-[76px] sm:w-[100px]">{dotted(news.dateSort)}</span>
                  <span className="shrink-0 whitespace-nowrap border border-[#a38e65]/60 text-[#8f7a56] text-[11px] tracking-[0.04em] py-1 w-[104px] text-center">{news.categoryLabel}</span>
                  <h3 className="flex-1 min-w-0 jba-display font-normal text-[#1a2942] text-[15px] sm:text-lg leading-[1.6] tracking-[0.01em] group-hover:text-[#8f7a56] transition-colors truncate sm:whitespace-normal">{news.title}</h3>
                  <span className="hidden sm:inline-flex items-center gap-1.5 shrink-0 font-['Noto_Serif_JP',serif] text-sm text-[#8f7a56]">詳しく <span className="text-[#a38e65] group-hover:translate-x-1 transition-transform inline-block">→</span></span>
                </Link>
              ) : (
                <div
                  key={news.id}
                  className="flex items-center gap-4 sm:gap-6 py-5 border-b border-[#e2ddd2]"
                >
                  <span className="font-['Playfair_Display',serif] italic text-[#8f7a56] text-sm shrink-0 w-[76px] sm:w-[100px]">{dotted(news.dateSort)}</span>
                  <span className="shrink-0 whitespace-nowrap border border-[#a38e65]/40 text-[#a89e8b] text-[11px] tracking-[0.04em] py-1 w-[104px] text-center">{news.categoryLabel}</span>
                  <h3 className="flex-1 min-w-0 jba-display font-normal text-[#4a4638] text-[15px] sm:text-lg leading-[1.6] tracking-[0.01em] truncate sm:whitespace-normal">{news.title}</h3>
                </div>
              )
            ))}
          </div>

          {/* 結果が見つからない場合 */}
          {sortedNews.length === 0 && (
            <div className="text-center py-16 sm:py-20">
              <h3 className="text-xl sm:text-2xl jba-display font-medium text-[#1a2942] mb-3">該当するニュースが見つかりません</h3>
              <p className="text-base text-[#666] font-['Noto_Serif_JP',serif]">別の種別をお試しください。</p>
            </div>
          )}

          <div className="text-center mt-14">
            <a href="/" className={BTN08_ON_LIGHT}>トップページへ戻る</a>
          </div>
        </div>
      </section>
    </Layout>
  );
}
